import React from 'react'
import PropTypes from 'prop-types'
import ModalHouseCommon from 'src/components/house/ModalHouseCommon'
import Event from 'src/assets/img/house/event.png'

const ModalHelp = ({ open, onClose }) => {
  return (
    <ModalHouseCommon
      open={open}
      onClose={onClose}
      height="max-h-[90%] max-w-[90%] xs:max-w-[350px]"
    >
      <div className="relative w-full flex flex-col overflow-auto hidden-scroll font-ShinMaruGo">
        <div className="sticky top-0 z-20 flex-shrink-0 flex w-full gap-2 border-b-[3px] rounded-tl-3xl border-house-pink bg-cream">
          <div className="max-w-1/3 py-2 rounded-tl-[16px] bg-house-pink bg-pat01">
            <span className="pl-4 pr-8 text-white text-xl tracking-wider font-semibold">
              遊び方
            </span>
          </div>
        </div>

        <div className="bg-pat02 p-4">
          <div className="max-h-[70vh] scrollbar-custom scroll-auto overflow-auto">
            <img className="w-full" src={Event} alt="Event" />
          </div>
        </div>
      </div>
    </ModalHouseCommon>
  )
}

ModalHelp.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default ModalHelp
